<div class="table-responsive">
  <table class="table table-striped table-hover">
    <thead class="table-light">
    <tr>
      <th>Conversion ID</th>
      <th>Offer</th>
      <th>Date</th>
      <th>Revenue</th>
      <th>Tracker1</th>
      <th>Tracker2</th>
      <th>Tracker3</th>
      <th>Tracker4</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let statistic of statistics">
      <td>{{ statistic.id }}</td>
      <td>
        <a *ngIf="statistic.offer" [routerLink]="['/offer', statistic.offer.id]">
          {{ statistic.offer.name }}
        </a>
      </td>
      <td>{{ statistic.getDate() | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
      <td>{{ statistic.revenue | money }}</td>
      <td>{{ statistic.tc1 }}</td>
      <td>{{ statistic.tc2 }}</td>
      <td>{{ statistic.tc3 }}</td>
      <td>{{ statistic.tc4 }}</td>
    </tr>
    </tbody>
  </table>
</div>

<app-paginator (pageChange)="fetchConversions()" [paginator]="paginator"></app-paginator>
